/*
 * Grippatch - koleksiyon filtresi fiyat alani bicimlendirme
 *
 * Kullanici "3000" yazinca alanda "3.000" gorunur (yaninda sabit "TL"
 * eki durur). Magazanin para bicimi `{{amount}} TL`, binlik ayraci ".".
 *
 * NEDEN type="text": `<input type="number">` binlik ayraci KABUL ETMEZ -
 * "3.000" yazildigi anda deger gecersiz sayilir ve `value` bos doner.
 * Bu yuzden alan metin, `inputmode="numeric"` ile mobilde yine rakam
 * tusu aciliyor.
 *
 * SUBMIT'TE HAM DEGER: Shopify filtre parametresi duz sayi bekler
 * (`filter.v.price.gte=3000`). Form gonderilirken noktalar sokuluyor.
 * Boylece ekranda bicimli, sunucuya ham gidiyor.
 */

(function () {
  'use strict';

  function bicimle(rakamlar) {
    if (!rakamlar) return '';
    // Bastaki gereksiz sifirlari at ("007" -> "7"), tek "0" kalabilir
    var s = rakamlar.replace(/^0+(?=\d)/, '');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function sadeceRakam(metin) {
    return String(metin == null ? '' : metin).replace(/\D/g, '');
  }

  /* Imlecin SOLUNDAKI rakam sayisini koruyarak yeniden konumlandirir.
     Aksi halde her tuşta imlec sona ziplar ve ortadan duzeltme yapilamaz. */
  function imlecKoru(alan, oncekiSol) {
    var sayac = 0;
    var i = 0;
    for (; i < alan.value.length; i++) {
      if (/\d/.test(alan.value[i])) sayac++;
      if (sayac >= oncekiSol) { i++; break; }
    }
    if (oncekiSol === 0) i = 0;
    try { alan.setSelectionRange(i, i); } catch (e) { /* bazi tarayicilar text disinda destekemez */ }
  }

  function kur(alan) {
    if (alan.dataset.paraHazir === '1') return;
    alan.dataset.paraHazir = '1';

    // Liquid degeri "3000.00" bicimindedir; tam sayiya indiriliyor
    var ilk = parseFloat(alan.value);
    alan.value = isNaN(ilk) ? '' : bicimle(String(Math.round(ilk)));

    alan.addEventListener('input', function () {
      var solRakam = sadeceRakam(alan.value.slice(0, alan.selectionStart || 0)).length;
      alan.value = bicimle(sadeceRakam(alan.value));
      imlecKoru(alan, solRakam);
    });

    // Yapistirmada da ayni yol izlensin
    alan.addEventListener('change', function () {
      alan.value = bicimle(sadeceRakam(alan.value));
    });
  }

  function formKur(form) {
    if (form.dataset.paraFormHazir === '1') return;
    form.dataset.paraFormHazir = '1';
    form.addEventListener('submit', function () {
      form.querySelectorAll('[data-para-alani]').forEach(function (alan) {
        // Ekranda bicimli kalsin diye DEGERI degistirip geri koymuyoruz;
        // gonderim aninda ham hali yaziliyor, sayfa zaten yenileniyor.
        alan.value = sadeceRakam(alan.value);
      });
    });
  }

  function hepsi() {
    document.querySelectorAll('[data-para-alani]').forEach(kur);
    document.querySelectorAll('form[data-filter-form]').forEach(formKur);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsi);
  } else {
    hepsi();
  }
  document.addEventListener('shopify:section:load', hepsi);
})();
